import { c as elementTransitionEnd, f as getDocument, l as isObject, r as elementChildren, t as Swiper, u as nextTick } from "./swiper.esm-Dvfjl6Fb.js";
import { t as Mousewheel } from "./mousewheel-C-gtMpkm.js";
import { t as Navigation } from "./navigation-BSfLh-wX.js";
import { t as Pagination } from "./pagination-U6_Jfzrd.js";
//#region node_modules/.pnpm/swiper@9.4.1/node_modules/swiper/modules/controller/controller.js
function Controller({ swiper, extendParams, on }) {
	extendParams({ controller: {
		control: void 0,
		inverse: false,
		by: "slide"
	} });
	swiper.controller = { control: void 0 };
	function LinearSpline(x, y) {
		const binarySearch = function search() {
			let maxIndex;
			let minIndex;
			let guess;
			return (array, val) => {
				minIndex = -1;
				maxIndex = array.length;
				while (maxIndex - minIndex > 1) {
					guess = maxIndex + minIndex >> 1;
					if (array[guess] <= val) minIndex = guess;
					else maxIndex = guess;
				}
				return maxIndex;
			};
		}();
		this.x = x;
		this.y = y;
		this.lastIndex = x.length - 1;
		let i1;
		let i3;
		this.interpolate = function interpolate(x2) {
			if (!x2) return 0;
			i3 = binarySearch(this.x, x2);
			i1 = i3 - 1;
			return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
		};
		return this;
	}
	function getInterpolateFunction(c) {
		swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
	}
	function setTranslate(_t, byController) {
		const controlled = swiper.controller.control;
		let multiplier;
		let controlledTranslate;
		const Swiper = swiper.constructor;
		function setControlledTranslate(c) {
			if (c.destroyed) return;
			const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
			if (swiper.params.controller.by === "slide") {
				getInterpolateFunction(c);
				controlledTranslate = -swiper.controller.spline.interpolate(-translate);
			}
			if (!controlledTranslate || swiper.params.controller.by === "container") {
				multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
				if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) multiplier = 1;
				controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
			}
			if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
			c.updateProgress(controlledTranslate);
			c.setTranslate(controlledTranslate, swiper);
			c.updateActiveIndex();
			c.updateSlidesClasses();
		}
		if (Array.isArray(controlled)) {
			for (let i = 0; i < controlled.length; i += 1) if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
		} else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
	}
	function setTransition(duration, byController) {
		const Swiper = swiper.constructor;
		const controlled = swiper.controller.control;
		let i;
		function setControlledTransition(c) {
			if (c.destroyed) return;
			c.setTransition(duration, swiper);
			if (duration !== 0) {
				c.transitionStart();
				if (c.params.autoHeight) nextTick(() => {
					c.updateAutoHeight();
				});
				elementTransitionEnd(c.wrapperEl, () => {
					if (!controlled) return;
					c.transitionEnd();
				});
			}
		}
		if (Array.isArray(controlled)) {
			for (i = 0; i < controlled.length; i += 1) if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
		} else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
	}
	function removeSpline() {
		if (!swiper.controller.control) return;
		if (swiper.controller.spline) {
			swiper.controller.spline = void 0;
			delete swiper.controller.spline;
		}
	}
	on("beforeInit", () => {
		if (typeof window !== "undefined" && (typeof swiper.params.controller.control === "string" || swiper.params.controller.control instanceof HTMLElement)) {
			const controlElement = document.querySelector(swiper.params.controller.control);
			if (controlElement && controlElement.swiper) swiper.controller.control = controlElement.swiper;
			else if (controlElement) {
				const onControllerSwiper = (e) => {
					swiper.controller.control = e.detail[0];
					swiper.update();
					controlElement.removeEventListener("init", onControllerSwiper);
				};
				controlElement.addEventListener("init", onControllerSwiper);
			}
			return;
		}
		swiper.controller.control = swiper.params.controller.control;
	});
	on("update", () => {
		removeSpline();
	});
	on("resize", () => {
		removeSpline();
	});
	on("observerUpdate", () => {
		removeSpline();
	});
	on("setTranslate", (_s, translate, byController) => {
		if (!swiper.controller.control || swiper.controller.control.destroyed) return;
		swiper.controller.setTranslate(translate, byController);
	});
	on("setTransition", (_s, duration, byController) => {
		if (!swiper.controller.control || swiper.controller.control.destroyed) return;
		swiper.controller.setTransition(duration, byController);
	});
	Object.assign(swiper.controller, {
		setTranslate,
		setTransition
	});
}
//#endregion
//#region node_modules/.pnpm/swiper@9.4.1/node_modules/swiper/modules/thumbs/thumbs.js
function Thumb({ swiper, extendParams, on }) {
	extendParams({ thumbs: {
		swiper: null,
		multipleActiveThumbs: true,
		autoScrollOffset: 0,
		slideThumbActiveClass: "swiper-slide-thumb-active",
		thumbsContainerClass: "swiper-thumbs"
	} });
	let initialized = false;
	let swiperCreated = false;
	swiper.thumbs = { swiper: null };
	function onThumbClick() {
		const thumbsSwiper = swiper.thumbs.swiper;
		if (!thumbsSwiper || thumbsSwiper.destroyed) return;
		const clickedIndex = thumbsSwiper.clickedIndex;
		const clickedSlide = thumbsSwiper.clickedSlide;
		if (clickedSlide && clickedSlide.classList.contains(swiper.params.thumbs.slideThumbActiveClass)) return;
		if (typeof clickedIndex === "undefined" || clickedIndex === null) return;
		let slideToIndex;
		if (thumbsSwiper.params.loop) slideToIndex = parseInt(thumbsSwiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
		else slideToIndex = clickedIndex;
		if (swiper.params.loop) swiper.slideToLoop(slideToIndex);
		else swiper.slideTo(slideToIndex);
	}
	function init() {
		const { thumbs: thumbsParams } = swiper.params;
		if (initialized) return false;
		initialized = true;
		const SwiperClass = swiper.constructor;
		if (thumbsParams.swiper instanceof SwiperClass) {
			swiper.thumbs.swiper = thumbsParams.swiper;
			Object.assign(swiper.thumbs.swiper.originalParams, {
				watchSlidesProgress: true,
				slideToClickedSlide: false
			});
			Object.assign(swiper.thumbs.swiper.params, {
				watchSlidesProgress: true,
				slideToClickedSlide: false
			});
			swiper.thumbs.swiper.update();
		} else if (isObject(thumbsParams.swiper)) {
			const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
			Object.assign(thumbsSwiperParams, {
				watchSlidesProgress: true,
				slideToClickedSlide: false
			});
			swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
			swiperCreated = true;
		}
		swiper.thumbs.swiper.el.classList.add(swiper.params.thumbs.thumbsContainerClass);
		swiper.thumbs.swiper.on("tap", onThumbClick);
		return true;
	}
	function update(initial) {
		const thumbsSwiper = swiper.thumbs.swiper;
		if (!thumbsSwiper || thumbsSwiper.destroyed) return;
		const slidesPerView = thumbsSwiper.params.slidesPerView === "auto" ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
		let thumbsToActivate = 1;
		const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
		if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
		if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
		thumbsToActivate = Math.floor(thumbsToActivate);
		thumbsSwiper.slides.forEach((slideEl) => slideEl.classList.remove(thumbActiveClass));
		if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for (let i = 0; i < thumbsToActivate; i += 1) elementChildren(thumbsSwiper.slidesEl, `[data-swiper-slide-index="${swiper.realIndex + i}"]`).forEach((slideEl) => {
			slideEl.classList.add(thumbActiveClass);
		});
		else for (let i = 0; i < thumbsToActivate; i += 1) if (thumbsSwiper.slides[swiper.realIndex + i]) thumbsSwiper.slides[swiper.realIndex + i].classList.add(thumbActiveClass);
		const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
		const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
		if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
			const currentThumbsIndex = thumbsSwiper.activeIndex;
			let newThumbsIndex;
			let direction;
			if (thumbsSwiper.params.loop) {
				const newThumbsSlide = thumbsSwiper.slides.filter((slideEl) => slideEl.getAttribute("data-swiper-slide-index") === `${swiper.realIndex}`)[0];
				newThumbsIndex = thumbsSwiper.slides.indexOf(newThumbsSlide);
				direction = swiper.activeIndex > swiper.previousIndex ? "next" : "prev";
			} else {
				newThumbsIndex = swiper.realIndex;
				direction = newThumbsIndex > swiper.previousIndex ? "next" : "prev";
			}
			if (useOffset) newThumbsIndex += direction === "next" ? autoScrollOffset : -1 * autoScrollOffset;
			if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
				if (thumbsSwiper.params.centeredSlides) if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
				else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
				else if (newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup === 1) {}
				thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : void 0);
			}
		}
	}
	on("beforeInit", () => {
		const { thumbs } = swiper.params;
		if (!thumbs || !thumbs.swiper) return;
		if (typeof thumbs.swiper === "string" || thumbs.swiper instanceof HTMLElement) {
			const document = getDocument();
			const getThumbsElementAndInit = () => {
				const thumbsElement = typeof thumbs.swiper === "string" ? document.querySelector(thumbs.swiper) : thumbs.swiper;
				if (thumbsElement && thumbsElement.swiper) {
					thumbs.swiper = thumbsElement.swiper;
					init();
					update(true);
				} else if (thumbsElement) {
					const onThumbsSwiper = (e) => {
						thumbs.swiper = e.detail[0];
						thumbsElement.removeEventListener("init", onThumbsSwiper);
						init();
						update(true);
						thumbs.swiper.update();
						swiper.update();
					};
					thumbsElement.addEventListener("init", onThumbsSwiper);
				}
				return thumbsElement;
			};
			const watchForThumbsToAppear = () => {
				if (swiper.destroyed) return;
				if (!getThumbsElementAndInit()) requestAnimationFrame(watchForThumbsToAppear);
			};
			requestAnimationFrame(watchForThumbsToAppear);
		} else {
			init();
			update(true);
		}
	});
	on("slideChange update resize observerUpdate", () => {
		update();
	});
	on("setTransition", (_s, duration) => {
		const thumbsSwiper = swiper.thumbs.swiper;
		if (!thumbsSwiper || thumbsSwiper.destroyed) return;
		thumbsSwiper.setTransition(duration);
	});
	on("beforeDestroy", () => {
		const thumbsSwiper = swiper.thumbs.swiper;
		if (!thumbsSwiper || thumbsSwiper.destroyed) return;
		if (swiperCreated) thumbsSwiper.destroy();
	});
	Object.assign(swiper.thumbs, {
		init,
		update
	});
}
//#endregion
//#region src/scripts/extenders/media-swiper.js
var MediaSwiper = class extends HTMLElement {
	constructor() {
		super();
		const thumbsHolder = this.querySelector(".thumbs");
		const mediaHolder = this.querySelector(".media-slider");
		const slidesPerView = window.innerWidth < 768 ? "auto" : 1.75;
		const thumbs = new Swiper(thumbsHolder, {
			modules: [Controller],
			slidesPerView: "auto",
			direction: "vertical",
			spaceBetween: 16,
			watchSlidesProgress: true,
			slideToClickedSlide: true
		});
		const media = new Swiper(mediaHolder, {
			modules: [
				Navigation,
				Controller,
				Mousewheel,
				Thumb,
				Pagination
			],
			slidesPerView,
			centeredSlides: true,
			spaceBetween: 24,
			mousewheel: { forceToAxis: true },
			thumbs: { swiper: thumbs },
			navigation: {
				prevEl: ".swiper-button-prev",
				nextEl: ".swiper-button-next"
			},
			pagination: {
				el: ".swiper-pagination",
				renderBullet: (index) => {
					if (index === 0) return `<span class="swiper-pagination-bullet active-right"></span>`;
					else return `<span class="swiper-pagination-bullet"></span>`;
				}
			}
		});
		const removeAllClasses = (bullets) => {
			bullets.forEach((bullet) => {
				bullet.classList.remove("active-right");
				bullet.classList.remove("active-left");
				bullet.classList.remove("out-left");
				bullet.classList.remove("out-right");
			});
		};
		media.on("slideNextTransitionStart", (swiper) => {
			const bullets = document.querySelectorAll(".swiper-pagination-bullet");
			const currentSlide = bullets[swiper.activeIndex - 1];
			const nextSlide = bullets[swiper.activeIndex];
			removeAllClasses(bullets);
			currentSlide.classList.add("out-right");
			nextSlide.classList.add("active-right");
		});
		media.on("slidePrevTransitionStart", (swiper) => {
			const bullets = document.querySelectorAll(".swiper-pagination-bullet");
			const currentSlide = bullets[swiper.activeIndex + 1];
			const nextSlide = bullets[swiper.activeIndex];
			removeAllClasses(bullets);
			currentSlide.classList.add("out-left");
			nextSlide.classList.add("active-left");
		});
	}
};
if (customElements.get("media-swiper") === void 0) customElements.define("media-swiper", MediaSwiper);
//#endregion
